export default __webpack_public_path__ + "static/media/photo--lg--97.86b9c6b2.jpg";